import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["auxiliaryText", "checked", "defaultChecked", "disabled", "label", "onKeyDown", "truncate"];
import React, { forwardRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Checkbox from '../Checkbox';
import { FormControlLabel } from '../Form';
import { StyledDropdownItem } from './sharedStyles';
import useDropdownContext from './useDropdownContext';
import DropdownLabel from './DropdownLabel';
const Root = styled(Checkbox).withConfig({
  displayName: "DropdownCheckbox__Root",
  componentId: "sc-1qi1icn-0"
})(["", ";display:flex;&:focus,&:focus-within{box-shadow:none;}", "{cursor:pointer;flex:1;min-width:0;}"], StyledDropdownItem, FormControlLabel.Style);
const DropdownCheckbox = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      auxiliaryText,
      checked,
      defaultChecked,
      disabled,
      label,
      onKeyDown,
      truncate
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    keyboardNavigationProps
  } = useDropdownContext();
  const handleOnKeyDown = useCallback(event => {
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
    if (event.key === 'Enter') event.target.click();
  }, [onKeyDown]);
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    ref: ref,
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    tabIndex: "-1",
    onKeyDown: handleOnKeyDown
  }, keyboardNavigationProps, {
    label: /*#__PURE__*/React.createElement(DropdownLabel, {
      label: label,
      auxiliaryText: auxiliaryText,
      truncate: truncate
    })
  }));
});
DropdownCheckbox.displayName = 'DropdownCheckbox';
DropdownCheckbox.Style = Root;
DropdownCheckbox.defaultProps = {
  auxiliaryText: '',
  defaultChecked: false,
  disabled: false,
  truncate: false
};
process.env.NODE_ENV !== "production" ? DropdownCheckbox.propTypes = {
  /**
   * Sets the auxiliary text.
   */
  auxiliaryText: PropTypes.string,
  /**
   * Sets the `Checkbox` checked by default. Used for **uncontrolled** component.
   */
  defaultChecked: PropTypes.bool,
  /**
   * Disables the `Dropdown.Checkbox`.
   */
  disabled: PropTypes.bool,
  /**
   * Sets the label.
   */
  label: PropTypes.string.isRequired,
  /**
   * Identifies that the label and the auxiliary text will
   * be truncated when it exceeds the available size.
   */
  truncate: PropTypes.bool
} : void 0;
export default DropdownCheckbox;